/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IntroductionPane from './IntroductionPane';
import Spinner from 'components/Spinner';
import H1 from 'components/deprecated/legacyElements/H1';
import SpaceCalculatorMeta from './SpaceCalculatorMeta';
import SpaceEstimationForm from './SpaceEstimationForm';
import SpacePieChart from './SpacePieChart';
import steps from './steps';
import styles from './SpaceCalculatorPage.scss';

const fakeLoadDuration = 1000;

export default class SpaceCalculatorPageView extends Component {
  componentWillUnmount() {
    if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
  }

  onUpdateStep = (newStep) => {
    this.props.onUpdateStep(newStep);
  }

  fakeLoadThenDisplayForm = () => {
    this.onUpdateStep(steps.loading);
    this.loadingTimeout = setTimeout(() => this.onUpdateStep(steps.chartDisplay), fakeLoadDuration);
  }

  renderRightPaneContent() {
    const pieChartProps = ((subProps = { chartSlices, numEmployees, onHoverSlice, selectedSlice, totalSqft }) => subProps)(this.props);

    switch(this.props.currentStep) {
      case steps.introduction:
        return <IntroductionPane />;

      case steps.chartDisplay:
        return <SpacePieChart { ...pieChartProps } />;

      default:
        return (
          <div className={styles.loadingContainer}>
            <Spinner />
            Calculating your space estimate...
          </div>
        );
    }
  }

  render() {
    const estimationFormProps = ((subProps = { currentUser, numEmployees, onAddRoom, onChange, onUpdateRoom, rooms, roomTypes, spacePerEmployee }) => subProps)(this.props);

    return (
      <div className={`inset ${styles.container}`}>
        <SpaceCalculatorMeta />

        <H1 className={styles.pageTitle}>Office Space Calculator</H1>

        <div className={styles.panes}>
          <div className={styles.leftPane}>
            <SpaceEstimationForm { ...estimationFormProps } onSubmit={this.fakeLoadThenDisplayForm} />
          </div>

          <div className={styles.rightPane}>
            {this.renderRightPaneContent()}
          </div>
        </div>
      </div>
    );
  }
}

SpaceCalculatorPageView.propTypes = {
  currentUser: PropTypes.object,
  totalSqft: PropTypes.number,
  numEmployees: PropTypes.number,
  spacePerEmployee: PropTypes.number,
  cities: PropTypes.array,
  onCityChange: PropTypes.func,
  currentStep: PropTypes.oneOf(Object.values(steps)),
  selectedCity: PropTypes.string,
  rooms: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    count: PropTypes.number,
    totalSize: PropTypes.number,
  })),
  roomTypes: PropTypes.array,
  chartSlices: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    value: PropTypes.number,
    count: PropTypes.number,
  })),
  selectedSlice: PropTypes.number,
  onChange: PropTypes.func,
  onUpdateStep: PropTypes.func,
  onAddRoom: PropTypes.func,
  onUpdateRoom: PropTypes.func,
  onHoverSlice: PropTypes.func,
};
